import type { QueryClient } from '@tanstack/react-query';
import { invalidateAfterBookingPayment } from './invalidate-booking-payment';

/**
 * After a payment or a void on an invoice. A bike invoice's money belongs to
 * its booking: a void hands it back as credit and puts the booking back on
 * Bookings to receive, and a balance payment changes the booking's money card,
 * so those refresh too rather than waiting out the stale time.
 */
export function invalidateAfterInvoiceMoney(
  queryClient: QueryClient,
  invoice: { uid: string; bookingUid: string | null },
): void {
  void queryClient.invalidateQueries({ queryKey: ['invoice', invoice.uid] });
  void queryClient.invalidateQueries({ queryKey: ['invoices'] });
  void queryClient.invalidateQueries({ queryKey: ['till-session'] });
  if (invoice.bookingUid !== null) invalidateAfterBookingPayment(queryClient, invoice.bookingUid);
}
